import {
  FungibleConditionCode,
  FungiblePostCondition,
  NonFungibleConditionCode,
  NonFungiblePostCondition,
  PostConditionType,
  STXPostCondition,
} from '@stacks/transactions';

import { stacksValue } from './stacks-value';
import { IMultisigTransaction } from './transform-multisig-transaction';

export const getAmountFromPostCondition = (
  pc: STXPostCondition | FungiblePostCondition | NonFungiblePostCondition
) => {
  if (pc.conditionType === PostConditionType.Fungible) return pc.amount.toString();
  if (pc.conditionType === PostConditionType.STX)
    return stacksValue({ value: pc.amount.toString(), withTicker: false });

  return '';
};

export const getNameFromPostCondition = (
  pc: STXPostCondition | FungiblePostCondition | NonFungiblePostCondition
) => {
  if ('assetInfo' in pc) {
    return pc.assetInfo.assetName.content;
  }

  return 'STX';
};

const getTitleFromConditionCode = (code: FungibleConditionCode | NonFungibleConditionCode) => {
  switch (code) {
    case FungibleConditionCode.Equal:
      return 'will transfer exactly';
    case FungibleConditionCode.Greater:
      return 'will transfer more than';
    case FungibleConditionCode.GreaterEqual:
      return 'will transfer equal to or greater than';
    case FungibleConditionCode.Less:
      return 'will transfer less than';
    case FungibleConditionCode.LessEqual:
      return 'will transfer less than or equal to';
    case NonFungibleConditionCode.Sends:
      return 'will transfer';
    case NonFungibleConditionCode.DoesNotSend:
      return 'will keep';
    default:
      return '';
  }
};

export const getPostConditionTitle = (
  pc: STXPostCondition | FungiblePostCondition | NonFungiblePostCondition
) => {
  return getTitleFromConditionCode(pc.conditionCode) || '';
};

export const isContractCallTx = (tx: IMultisigTransaction) =>
  ['transfer-sip-009', 'transfer-sip-010', 'contract-call'].includes(tx.internalTxType);
